import React from 'react';
import { useAmazonProfile } from '../contexts/AmazonProfileContext';
import { useFeatureAccess } from '../hooks/useFeatureAccess';
import { SELLERCLUB_SUPPORT_PHONE, SELLERCLUB_SUPPORT_PHONE_DISPLAY } from '../constants/support';

function PendingApprovalBanner() {
  const { profiles } = useAmazonProfile();
  const { isAdmin } = useFeatureAccess();

  if (isAdmin) return null;

  const pending = (profiles || []).filter(
    (p) => p.storeStatus === 'pending_approval' || p.approvalPending
  );

  if (!pending.length) return null;

  const names = pending.map((p) => p.storeName || p.name).filter(Boolean).slice(0, 3);
  const nameHint = names.length ? ` (${names.join(', ')}${pending.length > names.length ? '…' : ''})` : '';

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3 text-sm text-amber-950 dark:bg-orange-950/40 dark:border-orange-500/30 dark:text-orange-50">
      <p className="font-semibold">Our team is onboarding your account</p>
      <p className="mt-1 text-amber-900/90 dark:text-orange-100/90">
        {pending.length} store{pending.length > 1 ? 's' : ''} awaiting SellerClub approval{nameHint}.
        You can sign in and view your stores; full tools unlock once approved.
      </p>
      <p className="mt-2">
        <span className="text-amber-900/80 dark:text-orange-200/90">Questions? </span>
        <a
          href={`tel:${SELLERCLUB_SUPPORT_PHONE}`}
          className="font-semibold text-orange-700 hover:text-orange-800 underline dark:text-orange-300"
        >
          Call {SELLERCLUB_SUPPORT_PHONE_DISPLAY}
        </a>
      </p>
    </div>
  );
}

export default PendingApprovalBanner;
